import { render, staticRenderFns } from "./CodebookDrawer.vue?vue&type=template&id=71f803a4"
import script from "./CodebookDrawer.vue?vue&type=script&lang=js"
export * from "./CodebookDrawer.vue?vue&type=script&lang=js"
import style0 from "./CodebookDrawer.vue?vue&type=style&index=0&id=71f803a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports